import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import GoalsInsightsComponent from 'webapp/components/goals/insights/index';

import type { GoalRecord } from 'webapp/models';
import type { Goal } from 'webapp/models-custom';

interface Args {
	model: GoalRecord;
}

export default class GoalsInsightsDetailRouteTemplate extends Component<Args> {
	@service('model-manager/goals') declare mmGoalsService: Service.ModelManager.Goals;

	get goal(): Goal {
		return this.mmGoalsService.findModel(this.args.model.id!)!;
	}

	<template><GoalsInsightsComponent @model={{this.goal}} /></template>
}
